/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from "../../../context/CardApplyContext";
import { post_card_apply } from '../../../redux/actions/card_apply/post_card_apply';
import { put_card_apply } from '../../../redux/actions/card_apply/put_card_apply';
import { delete_card_apply } from '../../../redux/actions/card_apply/delete_card_apply';
import Modal from '../Modal/index';


const CardApplyPreview: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const { formData } = useContext(Context)
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)

  const handleChange = (token: any, formData: any) => {
    if (id) {
      dispatch(put_card_apply({ id, token, data: formData, navigate }))
    } else {
      delete formData.id
      dispatch(post_card_apply({ token, data: formData, navigate }))
    }
  }


  const handleDelete = () => {
    dispatch(delete_card_apply({ id, token, data: formData, navigate }))
    //dispatch(get_banners({ lang: null, token }))
  }


  const successAction = () => {
    handleChange(token, formData)
    //dispatch(get_banners({ lang: null, token }))
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }


  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>

          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.description}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.href}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.button}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.apply}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.lang}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => {
        setShowModal(true)

      }} disabled={!formData.title || !formData.apply || !formData.lang || !formData.href || !formData.button}>
        {!id ? 'Publicar' : 'Guardar'} Información para aplicar
      </Button>

      {
        id ?
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de modificar esta información?'}
              text={' '}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal} />
          ) :
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de publicar esta información?'}
              text={''}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal}
            />
          )
      }


      {id && (
        <>
          <Button onClick={() => {
            setShowModalDelete(true)
          }}>
            Eliminar información
          </Button>
          <Modal
            show={showModalDelete}
            title={'¿Esta seguro de eliminar esta información?'}
            text={' '}
            onClickSuccess={handleDelete}
            onClickClose={closeModalDelete}
            btnSuccess={'Si'}
            btnWarning={"No"}
            onClickWarning={closeModalDelete}
          />
        </>
      )}
    </ContentSection>
  )
}


export default CardApplyPreview;